import React from 'react'
import StringMask from 'string-mask'
import * as FlexWebChat from '@twilio/flex-webchat-ui'
import { engagementValidator } from '../validators'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import Locales from '../locales'
import GAds from '../utils/gads'
import * as UserHelper from '../utils/user'

export class PreEngagementForm extends React.Component {
  state = {
    model: {
      name: '',
      lastName: '',
      email: '',
      phone: ''
    },
    errors: []
  }

  setPhone(value) {
    this.setState({
      ...this.state,
      model: {
        ...this.state.model,
        phone: value
      }
    })
  }

  componentDidMount() {
    console.log('PRE ENGAGEMENT FORM ANONYMOUS ')
  }

  onSubmit(e) {
    if (e) {
      e.preventDefault()
    }

    this.setState({ errors: {} })
    engagementValidator
      .create(this.state.model)
      .then((result) => {
        const language = Locales.getCurrentLanguage()
        const gclid = GAds.getGclid()

        if (result.success) {
          FlexWebChat.Actions.invokeAction('StartEngagement', {
            formData: {
              ...this.state.model,
              friendlyName: this.state.model.phone,
              language,
              gclid
            }
          })
          UserHelper.saveUserData({ ...this.state.model })
        } else {
          const errors = result.errors
          this.setState({ errors })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  render() {
    const { preEngagementConfig } = this.props
    const fields = this._getInputs()
    const translations = Locales.getTranslations()

    return (
      <>
        <div className='custom-form__body'>
          <p className='custom-form__text'>{preEngagementConfig.description}</p>
          <form onSubmit={this.onSubmit.bind(this)}>
            {fields}
            <FlexWebChat.Button
              disabled={false}
              type='submit'
              style={{
                color: 'white',
                fontSize: '13px',
                fontWeight: 'bold',
                borderRadius: '0.5rem',
                background: '#0f363c',
                margin: '0 auto',
                padding: '16px',
                textAlign: 'center',
                width: '100%',
                height: '56px'
              }}
            >
              {translations['form.submitLabel']}
            </FlexWebChat.Button>
          </form>
        </div>
      </>
    )
  }

  _getInputs = () => {
    const { preEngagementConfig } = this.props
    const { model } = this.state

    console.log({ fields: preEngagementConfig.fields })

    return preEngagementConfig.fields.map((field, index) => {
      const { name } = field.attributes
      const classes = ['custom-form__input-control']
      const hasError = this.state.errors[name]
      if (hasError) {
        classes.push('custom-form__input-control--has-error')
      }
      let { placeholder } = field.attributes
      if (field.attributes.required) {
        placeholder = `${placeholder}*`
      }
      const isMask = field.type === 'InputMaskItem'
      const isRadio = field.type === 'RadioItems'
      const isPhoneInput = field.type === 'PhoneItem'
      const mask = field.attributes.mask
      const value = this.state.model[name]

      return (
        <div key={index} className={classes.join(' ')}>
          {isRadio && (
            <div className='custom-form__radio-items'>
              <label>{field.attributes.placeholder}</label>
              <div className='custom-form__radio-items__options'>
                {field.options.map((radio, radioIndex) => {
                  const checked = radio.value === model.documentType
                  return (
                    <label key={radioIndex}>
                      <input
                        type='radio'
                        value={radio.value}
                        checked={checked}
                        onChange={() => {
                          this._handleChange('documentType')({
                            target: {
                              value: radio.value
                            }
                          })
                        }}
                      />
                      <span>{radio.label}</span>
                    </label>
                  )
                })}
              </div>
            </div>
          )}
          {isPhoneInput && (
            <label className='custom-form__label'>
              <span>{field?.label}</span>
              <PhoneInput
                value={this.state.model.phone}
                onChange={this.setPhone.bind(this)}
                className={'custom-form__input-child margin-left-5'}
              />
            </label>
          )}
          {!isMask && !isRadio && !isPhoneInput && (
            <label className='custom-form__label'>
              <span>{field?.label}</span>
              <input
                className='custom-form__input'
                value={value}
                onChange={this._handleChange(name)}
              />
            </label>
          )}
          {hasError && (
            <p className='custom-form__error-message'>{hasError.join(', ')}</p>
          )}
        </div>
      )
    })
  }

  _handleChange = (field) => {
    return (e) => {
      let { value } = e.target
      if (field === 'documentNumber') {
        const lastValue = this.state.model.documentNumber
        const lastChar = lastValue[lastValue.length - 1]
        const isDeleting = value.length < lastValue.length
        value = value.replace(/[^\d]/g, '')
        if (isDeleting && isNaN(+lastChar)) {
          value = value.substring(0, value.length - 1)
        }
        const mask = value.length > 11 ? '00.000.000/0000-00' : '000.000.000-00'
        const formatter = new StringMask(mask)
        value = formatter.apply(value)
      }
      const model = {
        ...this.state.model,
        [field]: value
      }
      this.setState({ model })
    }
  }
}
